import pmRequest from "@/utils/pmRequest";
//
/**
 * @desc 项目所有交付物
 *
 */
export function getProjectAllMfg(params) {
  return pmRequest({
    url: "/pm/mfg/getProjectAllMfg",
    method: "get",
    params
  });
}

export function getMfgList(params) {
  return pmRequest({
    url: "/pm/mfg/getMfgList",
    method: "get",
    params
  });
}
/**
 * @desc 获取交付物详情
 *
 */
export function getMfgDetail(params) {
  return pmRequest({
    url: "/pm/mfg/getMfgDetail",
    method: "get",
    params
  });
}

/**
 * @desc 新建/编辑交付物
 *
 */
export function postMfg(data) {
  return pmRequest({
    url: "/pm/mfg/postMfg",
    method: "post",
    data
  });
}
//
/**
 * @desc 删除交付物
 *
 */
export function deleteMfg(data) {
  return pmRequest({
    url: "/pm/mfg/deleteMfg",
    method: "post",
    data
  });
}
//
/**
 * @desc 开始制造
 *
 */
export function startMfg(data) {
  return pmRequest({
    url: "/pm/mfg/startMfg",
    method: "post",
    data
  });
}
/**
 * @desc 发货
 *
 */
export function deliverMfg(data) {
  return pmRequest({
    url: "/pm/mfg/deliverMfg",
    method: "post",
    data
  });
}

/**
 * @desc 验收
 *
 */

export function acceptMfg(data) {
  return pmRequest({
    url: "/pm/mfg/acceptMfg",
    method: "post",
    data
  });
}
//导入/重新导入BOM TODO
/**
 * @desc: 预上传
 * @param {*} data
 * @return {*}
 */
export function preUpload(params) {
  return pmRequest({
    url: "/pm/file/preUpload",
    method: "get",
    params
  });
}
/**
 * @desc: 上传完成
 * @param {*} data
 * @return {*}
 */
export function finishUpload(data) {
  return pmRequest({
    url: "/pm/file/finishUpload",
    method: "post",
    data
  });
}

/**
 * @desc: 企业项目（交付物）进度（状态为在制造）
 * @param {*} params
 * @return {*}
 */
export function getEnterpriseMfgListApi(params) {
  return pmRequest({
    url: "/pm/mfg/getEnterpriseMfgList",
    method: "get",
    params
  });
}

/**
 * @desc: 我的项目（交付物）进度（状态为在制造）
 * @param {*} params
 * @return {*}
 */
export function getMyMfgListApi(params) {
  return pmRequest({
    url: "/pm/mfg/getMyMfgList",
    method: "get",
    params
  });
}

/**
 * @desc: 我的项目（交付物）进度（状态为在制造）
 * @param {*} params
 * @return {*}
 */

export function deleteFile(data) {
  return pmRequest({
    url: "/pm/file/deleteFile",
    method: "post",
    data
  });
}

/**
 * @desc: 项目文件列表
 * @param {*} params
 * @return {*}
 */
export function getProjectFileListApi(params) {
  return pmRequest({
    url: "/pm/file/getProjectFileList",
    method: "get",
    params
  });
}

/**
 * @desc: 重命名文件
 * @param {*} params
 * @return {*}
 */

export function renameFileApi(data) {
  return pmRequest({
    url: "/pm/file/renameFile",
    method: "post",
    data
  });
}
